module.exports = __webpack_public_path__ + "static/pt-serif-v12-latin-700italic-abcd0499ddf538cfab2da3036dace8b6.woff";